import React, { useEffect, useState } from "react";
import { listCustomers, listOrdersByUser, createCoupon } from "../../services/analytics";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../firebase/config";
import { X, Ticket, Package, ShoppingCart } from "lucide-react";

export default function AdminCustomers() {
  const [users, setUsers] = useState([]);
  const [active, setActive] = useState(null);
  const [activeOrders, setActiveOrders] = useState([]);
  const [activeCart, setActiveCart] = useState(null);

  const [showCoupon, setShowCoupon] = useState(false);
  const [couponForm, setCouponForm] = useState({ code: "", discount_percent: 10 });
  const [couponMsg, setCouponMsg] = useState("");

  useEffect(() => { listCustomers().then(setUsers); }, []);

  const openUser = async (u) => {
    setActive(u);
    setActiveOrders([]);
    setActiveCart(null);
    const [orders, cartSnap] = await Promise.all([
      listOrdersByUser(u.uid),
      getDoc(doc(db, "carts", `u_${u.uid}`)),
    ]);
    setActiveOrders(orders);
    setActiveCart(cartSnap.exists() ? cartSnap.data() : null);
  };

  const saveCoupon = async () => {
    if (!couponForm.code) return;
    await createCoupon({
      code: couponForm.code,
      discount_percent: couponForm.discount_percent,
      user_id: active.uid,
      max_uses: 1,
    });
    setCouponMsg(`Kupon göndərildi: ${couponForm.code.toUpperCase()}`);
    setTimeout(() => { setCouponMsg(""); setShowCoupon(false); setCouponForm({ code: "", discount_percent: 10 }); }, 2500);
  };

  return (
    <div className="p-10" data-testid="admin-customers">
      <div className="metadata">İSTİFADƏÇİLƏR</div>
      <h1 className="font-display text-5xl mt-1">Müştərilər</h1>

      <div className="mt-8 border border-[var(--border)]">
        <div className="grid grid-cols-12 metadata px-4 py-3 border-b border-[var(--border)] bg-[var(--surface)]">
          <div className="col-span-3">E-POÇT</div>
          <div className="col-span-3">AD</div>
          <div className="col-span-2">TELEFON</div>
          <div className="col-span-1">ROL</div>
          <div className="col-span-3 text-right">QEYDİYYAT</div>
        </div>
        {users.map((u) => (
          <button key={u.uid} onClick={() => openUser(u)} className="grid grid-cols-12 px-4 py-3 border-b border-[var(--border-soft)] items-center text-sm w-full text-left hover:bg-[var(--surface)]">
            <div className="col-span-3 font-mono text-xs truncate">{u.email}</div>
            <div className="col-span-3 font-display">{u.full_name || "—"}</div>
            <div className="col-span-2 font-mono text-xs text-[var(--text-2)]">{u.phone || "—"}</div>
            <div className="col-span-1 metadata">{u.role === "admin" ? <span className="text-[var(--primary)]">ADMİN</span> : "MÜŞTƏRİ"}</div>
            <div className="col-span-3 text-right metadata text-[var(--text-muted)]">{u.created_at?.toDate?.().toLocaleDateString() || "—"}</div>
          </button>
        ))}
        {!users.length && <div className="p-10 text-center text-[var(--text-muted)] metadata">HƏLƏ MÜŞTƏRİ YOXDUR</div>}
      </div>

      {active && (
        <div className="fixed inset-0 z-50 bg-black/50 flex items-start justify-end" onClick={() => setActive(null)}>
          <div className="bg-[var(--bg)] border-l border-[var(--border)] w-full max-w-xl h-full overflow-y-auto p-8" onClick={(e) => e.stopPropagation()}>
            <div className="flex justify-between items-start mb-4">
              <div>
                <div className="metadata">MÜŞTƏRİ</div>
                <h2 className="font-display text-3xl mt-1">{active.full_name || active.email}</h2>
                <div className="metadata text-[var(--text-muted)] mt-1 font-mono">{active.email}</div>
                {active.phone && (
                  <div className="metadata text-[var(--text-muted)] mt-1 font-mono">📞 {active.phone}</div>
                )}
              </div>
              <button onClick={() => setActive(null)}><X /></button>
            </div>

            <div className="flex gap-2 mt-4">
              <button onClick={() => setShowCoupon(true)} className="btn-primary" data-testid="issue-coupon-btn"><Ticket size={14} /> KUPON VER</button>
            </div>

            {showCoupon && (
              <div className="mt-4 border border-[var(--primary)] p-4">
                <div className="metadata mb-3">YENİ KUPON ({active.email})</div>
                <div className="grid grid-cols-2 gap-3">
                  <div>
                    <label className="metadata text-[var(--text-muted)]">KOD</label>
                    <input className="w-full bg-transparent border border-[var(--border)] px-3 py-2 mt-1 font-mono" placeholder="WELCOME10" value={couponForm.code} onChange={(e) => setCouponForm({ ...couponForm, code: e.target.value })} />
                  </div>
                  <div>
                    <label className="metadata text-[var(--text-muted)]">FAİZ %</label>
                    <input type="number" className="w-full bg-transparent border border-[var(--border)] px-3 py-2 mt-1 font-mono" value={couponForm.discount_percent} onChange={(e) => setCouponForm({ ...couponForm, discount_percent: e.target.value })} />
                  </div>
                </div>
                {couponMsg && <div className="text-[var(--primary)] text-sm mt-3">{couponMsg}</div>}
                <div className="flex justify-end gap-2 mt-3">
                  <button onClick={() => setShowCoupon(false)} className="btn-outline">LƏĞV</button>
                  <button onClick={saveCoupon} className="btn-primary">VER</button>
                </div>
              </div>
            )}

            {/* Cart */}
            <div className="mt-8">
                <div className="flex items-center gap-2 metadata mb-3"><ShoppingCart size={14} /> CARİ SƏBƏT</div>
              {activeCart?.items?.length ? (
                <div className="space-y-2">
                  {activeCart.items.map((i) => (
                    <div key={i.product_id} className="flex items-center gap-3 border border-[var(--border-soft)] p-2">
                      {i.cover_url && <img src={i.cover_url} alt="" className="w-10 h-10 object-cover" />}
                      <div className="flex-1"><div className="font-display">{i.title}</div><div className="metadata text-[var(--text-muted)]">{i.artist_name}</div></div>
                      <div className="font-mono text-xs">x{i.qty}</div>
                      <div className="font-mono text-xs w-16 text-right">₼{Number(i.price_azn).toFixed(2)}</div>
                    </div>
                  ))}
                  <div className="flex justify-between metadata pt-2">
                    <span>CƏM</span><span className="font-mono">₼{Number(activeCart.total_azn || 0).toFixed(2)}</span>
                  </div>
                </div>
              ) : <div className="text-[var(--text-muted)] text-sm">Səbət boşdur.</div>}
            </div>

            {/* Orders */}
            <div className="mt-8">
              <div className="flex items-center gap-2 metadata mb-3"><Package size={14} /> SİFARİŞLƏR ({activeOrders.length})</div>
              {activeOrders.length ? (
                <div className="space-y-2">
                  {activeOrders.map((o) => (
                    <div key={o.id} className="border border-[var(--border-soft)] p-3">
                      <div className="flex justify-between">
                        <div className="font-mono text-xs">{o.tracking_no}</div>
                        <div className="metadata">{(o.status || "—").toUpperCase()}</div>
                      </div>
                      <div className="flex justify-between mt-1 text-sm">
                        <span className="text-[var(--text-2)]">{(o.items || []).length} məhsul</span>
                        <span className="font-mono">₼{Number(o.total_azn || 0).toFixed(2)}</span>
                      </div>
                    </div>
                  ))}
                </div>
              ) : <div className="text-[var(--text-muted)] text-sm">Sifariş yoxdur.</div>}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
